import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const GetQuestionsApi = createAsyncThunk(
  'GetQuestionsApi',
  async (getQuestionsPayload, { dispatch }) => {
    dispatch({ type: 'GetQuestionsApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = getQuestionsPayload;

    debug('LOOK', `getQuestionsPayload:`, getQuestionsPayload);
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerJourney/getquestion',
      payload: {
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Unfiltered Response: `, res);
        const getQuestionsRes = res;
        const { statusCode, body } = getQuestionsRes;
        let filtered;
        if (statusCode === 200) {
          let { custJourneyQue } = body;
          const ids = custJourneyQue.map((item) => item.questionId);
          console.log('ids', ids);
          filtered = custJourneyQue.filter(
            ({ questionId }, index) => !ids.includes(questionId, index + 1)
          );
          console.log('filtered', filtered);
          // custJourneyQue = filtered;
          getQuestionsRes.body.custJourneyQue = filtered;
        }
        console.log('Filtered Res', getQuestionsRes);
        dispatch({
          type: 'GetQuestionsApi/fulfilled',
          payload: getQuestionsRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'GetQuestionsApi/rejected', payload: err });
      },
    });
  }
);

export const GetQuestionsApi_extrareducer = {
  [GetQuestionsApi.pending]: (state, action) => {
    state.getQuestionsApiState.isLoading = true;
  },
  [GetQuestionsApi.fulfilled]: (state, action) => {
    state.getQuestionsApiState.isLoading = false;
    state.getQuestionsApiState.isSuccess = true;
    state.getQuestionsApiState.isError = false;
    state.getQuestionsApiState.response = action.payload;
  },
  [GetQuestionsApi.rejected]: (state, action) => {
    state.getQuestionsApiState.isLoading = false;
    state.getQuestionsApiState.isSuccess = false;
    state.getQuestionsApiState.isError = true;
    state.getQuestionsApiState.response = action.payload;
  },
};
